import React, { Component } from 'react';
import axios from '../../utils/axiosInstance';
import 'bootstrap/dist/css/bootstrap.min.css';
import './PostDetail.css';
import Facilities from './Facilities';
import GuestReviews from './GuestReviews';
import PostFAQ from './PostFAQ';
import SimilarProperties from './SimilarProperties';
import { withNavigation } from '../../utils/withNavigation';

class PostDetail extends Component {
  constructor(props) {
    super(props);

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth= today.getMonth();

    this.state = {
      // API & Data State
      hotel: null,
      loading: true,
      error: null,
      bookedDates: [],
      socialData: {
        email: "",
        whatsapp_number: "",
        social_link_1: "",
        social_link_2: "",
        social_link_3: "",
        social_link_4: "",
        powered_by: "",
      },

      // Booking & Date State
      checkIn: null,
      checkOut: null,
      leftCalendarBase: new Date(currentYear, currentMonth, 1),
      rightCalendarBase: new Date(currentYear, currentMonth, 1),
      showSidebarCalendar: false,

      // Guest State
      rooms: 1,
      adults: 1,
      ratings: 0,
      children: 0,
      cleaningFee: 0,
      discount: 0,
      post_booking_status: 0,

      // UI State
      isGalleryOpen: false,
      currentImageIndex: 0,
      isShareModalOpen: false,
      copied: false,
      isFavorite: false,

      // Form State
      remarks: '',
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);

    this.fetchFooterData();
    const id = this.props.params?.id;

    if (id) {
      this.loadPost(id);
      this.fetchBookedDates(id);
      this.updateRecentlyViewed(id);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  // --- API METHODS ---
  fetchFooterData = async () => {
    try {
      const res = await axios.get("/theme_customizable", {});
      if (res?.data?.data) {
        this.setState(p => ({ socialData: { ...p.socialData, ...res.data.data } }));
      }
      const res1 = await axios.get("/setting", {});
      if (res1?.data?.data) {
        this.setState(p => ({ socialData: { ...p.socialData, powered_by: res1.data.data.powered_by || "" } }));
      }
    } catch (error) {
      console.error("Footer fetch error:", error);
    }
  };

  loadPost = async (postId) => {
    this.setState({ loading: true, error: null });
    try {
      const res = await axios.get(`/get_post_by_id?id=${postId}`);
      const data = Array.isArray(res.data?.data) ? res.data.data[0] : res.data.data;

      if (!data) {
        this.setState({ error: "Property not found", loading: false });
        return;
      }

      let gallery = [];
      try {
        gallery = data.gallery_images ? JSON.parse(data.gallery_images) : [];
      } catch (e) {
        gallery = [];
      }

      data.all_images = data.feature_image ? [data.feature_image, ...gallery] : gallery;

      this.setState({
        hotel: data,
        post_booking_status: Number(data.post_booking_status) || 0,
        adults: data.adults ? Math.min(2, data.adults) : 1,
        ratings: data.ratings || 0,
        loading: false
      });
    } catch (err) {
      console.error("Fetch error:", err);
      this.setState({ error: "Failed to load property details", loading: false });
    }
  };

  fetchBookedDates = async (postId) => {
    try {
      const res = await axios.get(`/booked_dates?post_id=${postId}`);
      this.setState({ bookedDates: res.data.data || [] });
    } catch (e) {
      console.error("Booked dates fetch error:", e);
    }
  };

  updateRecentlyViewed = (id) => {
    let viewed = JSON.parse(localStorage.getItem("recently_viewed_products")) || [];
    viewed = viewed.filter((item) => parseInt(item) !== parseInt(id));
    viewed.unshift(id);
    viewed = viewed.slice(0, 20);
    localStorage.setItem("recently_viewed_products", JSON.stringify(viewed));
  };

  handleBooking = async () => {
    const { hotel, checkIn, checkOut, rooms, adults, children, remarks } = this.state;
    const { grandTotal } = this.calculateTotals();
    const web_user_id = localStorage.getItem("web_user_id");

    if (!web_user_id) {
      alert("Please login first");
      return;
    }
    if (!checkIn || !checkOut) {
      alert("Select dates first");
      return;
    }
    if (checkIn >= checkOut) {
      alert("Check-out date must be after check-in date.");
      return;
    }
    if (!this.isDateRangeFree(checkIn, checkOut)) {
      alert("Your selected range contains already booked dates. Please select free dates.");
      return;
    }

    try {
      await axios.post("book_room", {
        post_id: Number(hotel.id),
        customer_id: Number(web_user_id),
        host_id: Number(hotel.customer_id),
        checkin_date: this.getLocalDateString(checkIn),
        checkout_date: this.getLocalDateString(checkOut),
        rooms: Number(rooms),
        adults: Number(adults),
        children: Number(children),
        remarks,
        totalAmount: Number(grandTotal),
      });
      alert("Booking successful!");
      window.location.href = "/chat";
    } catch (e) {
      console.error(e);
      alert("Booking failed");
    }
  };

  // --- UTILITY METHODS ---
  getLocalDateString = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  isDateBlockedForCheckIn = (date) => {
    const dateStr = this.getLocalDateString(date);
    const { bookedDates } = this.state;
    for (let i = 0; i < bookedDates.length; i++) {
      const b = bookedDates[i];
      if (dateStr >= b.checkin_date && dateStr < b.checkout_date) return true;
    }
    return false;
  };

  isDateRangeFree = (start, end) => {
    const { bookedDates } = this.state;
    const startStr = this.getLocalDateString(start);
    const endStr = this.getLocalDateString(end);

    for (let i = 0; i < bookedDates.length; i++) {
      const b = bookedDates[i];
      if (startStr < b.checkout_date && endStr > b.checkin_date) {
        return false;
      }
    }
    return true;
  };

  copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        this.setState({ copied: true });
        setTimeout(() => this.setState({ copied: false }), 3000);
      })
      .catch(() => console.log("Copy failed"));
  };

  // --- GALLERY METHODS ---
  openGallery = (index = 0) => {
    this.setState({ isGalleryOpen: true, currentImageIndex: index });
    document.body.style.overflow = "hidden";
  };

  closeGallery = () => {
    this.setState({ isGalleryOpen: false });
    document.body.style.overflow = "unset";
  };

  nextImage = () => this.setState(p => ({
    currentImageIndex: (p.currentImageIndex + 1) % p.hotel.all_images.length
  }));

  prevImage = () => this.setState(p => ({
    currentImageIndex: (p.currentImageIndex === 0) ? p.hotel.all_images.length - 1 : p.currentImageIndex - 1
  }));

  handleKeyDown = (e) => {
    if (!this.state.isGalleryOpen) return;
    if (e.key === 'ArrowRight') this.nextImage();
    if (e.key === 'ArrowLeft') this.prevImage();
    if (e.key === 'Escape') this.closeGallery();
  };

  // --- MODAL & ACTION TOGGLES ---
  toggleShareModal = () => this.setState(p => ({ isShareModalOpen: !p.isShareModalOpen }));

  toggleFavorite = () => this.setState(p => ({ isFavorite: !p.isFavorite }));

  scrollToBooking = () => {
    const element = document.getElementById("booking-sidebar-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // --- CUSTOM DATE PICKER LOGIC ---
  handleDayClick = (clickedDate) => {
    const { checkIn, checkOut } = this.state;
    const todayStr = this.getLocalDateString(new Date());
    const clickedStr = this.getLocalDateString(clickedDate);

    if (clickedStr < todayStr) return;

    if (!checkIn || (checkIn && checkOut)) {
      if (this.isDateBlockedForCheckIn(clickedDate)) return;
      this.setState({ checkIn: clickedDate, checkOut: null });
    } else {
      if (clickedDate <= checkIn) {
        if (!this.isDateBlockedForCheckIn(clickedDate)) {
          this.setState({ checkIn: clickedDate });
        }
      } else {
        if (this.isDateRangeFree(checkIn, clickedDate)) {
          this.setState({ checkOut: clickedDate, showSidebarCalendar: false });
        } else {
          if (!this.isDateBlockedForCheckIn(clickedDate)) {
            this.setState({ checkIn: clickedDate });
          }
        }
      }
    }
  };

  changeMonth = (calendarType, offset) => {
    this.setState(p => {
      const current = p[calendarType];
      return { [calendarType]: new Date(current.getFullYear(), current.getMonth() + offset, 1) };
    });
  };

  formatDateString = (date) => {
    if (!date) return 'Select Date';
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  getNights = () => {
    const { checkIn, checkOut } = this.state;
    if (checkIn && checkOut) return Math.ceil(Math.abs(checkOut - checkIn) / (1000 * 60 * 60 * 24));
    return 0;
  };

  renderCalendarMonth = (baseDate) => {
    const year = baseDate.getFullYear();
    const month = baseDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const monthName = baseDate.toLocaleString('en-US', { month: 'long', year: 'numeric' });
    const { checkIn, checkOut } = this.state;
    const todayStr = this.getLocalDateString(new Date());
    const days = [];

    for (let i = 0; i < firstDay; i++) days.push(<div key={`empty-${i}`} className="cal-day empty"></div>);

    for (let d = 1; d <= daysInMonth; d++) {
      const currentDate = new Date(year, month, d);
      const currentStr = this.getLocalDateString(currentDate);
      let isPast = currentStr < todayStr;
      let isBooked = false;
      let statusClass = '';

      if (isPast) {
        isBooked = true;
        statusClass = 'text-muted text-decoration-line-through';
      } else if (!checkIn || (checkIn && checkOut)) {
        isBooked = this.isDateBlockedForCheckIn(currentDate);
        if (isBooked) statusClass = 'text-muted text-decoration-line-through';
      } else {
        if (currentDate <= checkIn) {
          if (this.isDateBlockedForCheckIn(currentDate)) {
            isBooked = true;
            statusClass = 'text-muted text-decoration-line-through';
          }
        } else {
          isBooked = !this.isDateRangeFree(checkIn, currentDate);
          if (isBooked) statusClass = 'text-muted text-decoration-line-through';
        }
      }

      if (checkIn && currentDate.getTime() === checkIn.getTime()) {
        statusClass += ' selected start-date';
      } else if (checkOut && currentDate.getTime() === checkOut.getTime()) {
        statusClass += ' selected end-date';
      } else if (checkIn && checkOut && currentDate > checkIn && currentDate < checkOut) {
        statusClass += ' in-range';
      }

      days.push(
        <button
          type="button"
          key={d}
          className={`cal-day ${statusClass.trim()}`}
          onClick={() => { if (!isBooked) this.handleDayClick(currentDate); }}
          disabled={isBooked}
          aria-label={`Select ${currentDate.toDateString()}`}
          style={isBooked ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
        >
          {d}
        </button>
      );
    }

    return (
      <div className="calendar-month-wrapper">
        <div className="calendar-month-title">{monthName}</div>
        <div className="cal-weekdays">
          <div>Su</div><div>Mo</div><div>Tu</div><div>We</div><div>Th</div><div>Fr</div><div>Sa</div>
        </div>
        <div className="cal-grid">{days}</div>
      </div>
    );
  };

  // --- GUEST, FORM & BOOKING HANDLERS ---
  handleGuestChange = (type, operation) => {
    this.setState(p => {
      let val = p[type];
      const maxVal = p.hotel[type] || (type === 'rooms' ? p.hotel.room_number : 10) || 10;

      if (operation === 'add' && val < maxVal) val++;
      if (operation === 'sub' && val > (type === 'children' ? 0 : 1)) val--;

      return { [type]: val };
    });
  };

  handleInputChange = (e) => this.setState({ [e.target.name]: e.target.value });

  calculateTotals = () => {
    const { hotel, cleaningFee, discount, rooms } = this.state;
    if (!hotel) return { totalNights: 0, roomPrice: 0, tax: 0, grandTotal: 0, pricePerNight: 0 };

    const pricePerNight = hotel.sales_price || 0;
    const totalNights = this.getNights() || 1;
    const roomPrice = pricePerNight * totalNights * rooms;
    const tax = 0;
    const grandTotal = roomPrice + cleaningFee + tax - discount;
    return { totalNights, roomPrice, tax, grandTotal, pricePerNight };
  };

  render() {
    const {
      hotel, loading, error, checkIn, checkOut, rooms, adults, ratings, children,
      cleaningFee, discount, showSidebarCalendar, leftCalendarBase,
      rightCalendarBase, isShareModalOpen, isGalleryOpen, currentImageIndex,
      remarks, copied, socialData, isFavorite, post_booking_status
    } = this.state;

    if (loading) return <div className="container py-5 text-center"><div className="spinner-border text-primary"></div><p className="mt-2">Loading property details...</p></div>;
    if (error) return <div className="container py-5"><div className="alert alert-danger">{error}</div></div>;
    if (!hotel) return null;

    const { totalNights, roomPrice, tax, grandTotal, pricePerNight } = this.calculateTotals();
    const nextMonthBase = new Date(leftCalendarBase.getFullYear(), leftCalendarBase.getMonth() + 1, 1);

    const baseUrl = axios.defaults.baseURL ? axios.defaults.baseURL.replace("/api", "") : "";
    const uploadUrl = `${baseUrl}/uploads/posts/`;
    const images = hotel.all_images.map(img => `${uploadUrl}${img}`);

    return (
      <div className="property-details-wrapper position-relative">

        {/* FULLSCREEN GALLERY MODAL */}
        {isGalleryOpen && (
          <div className="fullscreen-gallery" role="dialog" aria-modal="true">
            <button type="button" className="gallery-close" onClick={this.closeGallery} aria-label="Close gallery">
              <i className="fas fa-times"></i>
            </button>
            <div className="gallery-counter">{currentImageIndex + 1} / {images.length}</div>
            <button type="button" className="gallery-nav prev" onClick={this.prevImage} aria-label="Previous image">
              <i className="fas fa-chevron-left"></i>
            </button>
            <img src={images[currentImageIndex]} alt="Fullscreen Property" className="gallery-main-img animate-zoom" />
            <button type="button" className="gallery-nav next" onClick={this.nextImage} aria-label="Next image">
              <i className="fas fa-chevron-right"></i>
            </button>
            <div className="gallery-thumbnails">
              {images.map((img, idx) => (
                <button
                  type="button"
                  key={idx}
                  className={`gallery-thumb-button ${currentImageIndex === idx ? 'active' : ''}`}
                  onClick={() => this.setState({ currentImageIndex: idx })}
                >
                  <img src={img} alt={`thumb-${idx}`} className="gallery-thumb" />
                </button>
              ))}
            </div>
          </div>
        )}

        {/* SHARE MODAL */}
        {isShareModalOpen && (
          <div className="custom-modal-overlay" onClick={this.toggleShareModal}>
            <div className="custom-modal bg-white rounded-4 p-4 shadow-lg animate-zoom" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="share-title">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 id="share-title" className="fw-bold m-0">Share this listing</h4>
                <button type="button" className="modal-close-btn" onClick={this.toggleShareModal} aria-label="Close share dialog">
                  <i className="fas fa-times" />
                </button>
              </div>

              <div className="d-flex gap-3 mb-4 align-items-center">
                {images[0] && <img src={images[0]} alt="Property" className="share-property-image rounded-3 object-fit-cover" />}
                <div className="min-w-0">
                  <h6 className="fw-bold mb-1 text-truncate">{hotel.title}</h6>
                  <p className="text-secondary small m-0">{hotel.category_name}</p>
                </div>
              </div>

              <div className="row g-3">
                <div className="col-6">
                  <a href={socialData.social_link_1 || "#"} target="_blank" rel="noopener noreferrer" className="share-option text-decoration-none">
                    <i className="fab fa-facebook" /><span>Facebook</span>
                  </a>
                </div>
                <div className="col-6">
                  <a href={`https://wa.me/${socialData.whatsapp_number}`} target="_blank" rel="noopener noreferrer" className="share-option text-decoration-none">
                    <i className="fab fa-whatsapp" /><span>WhatsApp</span>
                  </a>
                </div>
                <div className="col-6">
                  <a href={socialData.social_link_2 || "#"} target="_blank" rel="noopener noreferrer" className="share-option text-decoration-none">
                    <i className="fab fa-twitter" /><span>Twitter</span>
                  </a>
                </div>
                <div className="col-6">
                  <a href={`mailto:${socialData.email}`} className="share-option text-decoration-none">
                    <i className="fas fa-envelope" /><span>Email</span>
                  </a>
                </div>
              </div>

              <div className="mt-4 p-3 bg-light rounded-3 d-flex align-items-center justify-content-between border">
                <span className="text-truncate text-secondary me-3 small">{window.location.href}</span>
                <button className="btn btn-sm btn-dark rounded-pill px-4" onClick={this.copyToClipboard}>
                  {copied ? "Copied!" : "Copy"}
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="container property-container">
          {/* Header (Desktop View) */}
          <div className="property-header animate-slide-up d-none d-md-flex">
            <div className="property-header-copy">
              <h1 className="property-title">{hotel.title}</h1>
              <div className="d-flex align-items-center gap-2 mt-2">
                {hotel.category_name && <span className="property-type-badge">{hotel.category_name}</span>}
                {hotel.room_type && <span className="property-type-badge text-purple-bg">{hotel.room_type}</span>}
              </div>
            </div>

            <div className="property-header-actions">
              <div className="property-rating-box">
                <div className="rating-value">
                  <i className="fas fa-star" /> {hotel.ratings || 'New'}
                </div>
                <div className="rating-reviews">
                  Verified Listing
                </div>
              </div>

              <button type="button" className="circle-action" onClick={this.toggleShareModal} aria-label="Share property">
                <i className="fas fa-share-alt" />
              </button>

              <button type="button" className={`circle-action favorite-action ${isFavorite ? 'is-favorite' : ''}`} onClick={this.toggleFavorite} aria-label="Save property">
                <i className={isFavorite ? 'fas fa-heart' : 'far fa-heart'} />
              </button>
            </div>
          </div>

          {/* Grid / Hero Gallery */}
          <div className="property-grid-gallery animate-fade-in">
            {/* Mobile Top Controls Bar Overlay */}
            <div className="mobile-gallery-top-bar d-flex d-md-none">
              <button 
                type="button" 
                className="mobile-round-btn" 
                onClick={() => this.props.navigate ? this.props.navigate(-1) : window.history.back()}
                aria-label="Go back"
              >
                <i className="fas fa-arrow-left" />
              </button>

              <div className="d-flex align-items-center gap-2">
                <button 
                  type="button" 
                  className="mobile-share-btn" 
                  onClick={this.toggleShareModal}
                  aria-label="Share listing"
                >
                  <i className="fas fa-share-alt me-1" />
                  <span>Share</span>
                </button>

                <button 
                  type="button" 
                  className={`mobile-round-btn ${isFavorite ? 'text-danger' : ''}`} 
                  onClick={this.toggleFavorite}
                  aria-label="Save listing"
                >
                  <i className={isFavorite ? 'fas fa-heart' : 'far fa-heart'} />
                </button>
              </div>
            </div>

            {/* Main Featured Photo */}
            <button type="button" className="gallery-main" onClick={() => this.openGallery(0)} aria-label="Open main property image">
              {images[0] && <img src={images[0]} alt="Main Property View" />}
            </button>

            {/* Desktop Grid Side Photos */}
            <div className="gallery-side d-none d-md-grid">
              {images.slice(1, 5).map((img, idx) => (
                <button type="button" key={idx} className="gallery-side-item" onClick={() => this.openGallery(idx + 1)} aria-label={`Open property image ${idx + 2}`}>
                  <img src={img} alt={`Property view ${idx + 2}`} />
                  {idx === 3 && images.length > 5 && (
                    <span className="more-images-overlay">
                      +{images.length - 5} More
                    </span>
                  )}
                </button>
              ))}
            </div>

            {/* Mobile "Show all photos" floating pill */}
            <button 
              type="button" 
              className="show-all-photos-btn d-inline-flex d-md-none" 
              onClick={() => this.openGallery(0)}
            >
              <i className="fas fa-th me-2" />
              Show all photos
            </button>
          </div>

          {/* Mobile Title & Details Info */}
          <div className="mobile-property-intro d-block d-md-none animate-slide-up mb-3">
            <h1 className="mobile-property-title">{hotel.title}</h1>
            
            <div className="mobile-badge-row">
              {hotel.category_name && <span className="mobile-soft-badge">{hotel.category_name}</span>}
              {hotel.room_type && <span className="mobile-soft-badge secondary">{hotel.room_type}</span>}
            </div>

            <div className="mobile-specs-row">
              <span>{hotel.adults || 0} guests</span>
              <span className="divider">|</span>
              <span>{hotel.bedrooms || hotel.rooms || 1} bedrooms</span>
              <span className="divider">|</span>
              <span>{hotel.beds || 0} beds</span>
              <span className="divider">|</span>
              <span>{hotel.baths || 0} baths</span>
              <span>{hotel.ratings || 0} ratings</span>
            </div>
          </div>

          <div className="row g-5 property-content-row">
            {/* Left Content (70%) */}
            <div className="col-lg-8 animate-slide-up">

              {/* Badges bar for Desktop */}
              <div className="detail-badges d-none d-md-flex">
                <div className="detail-badge"><i className="fas fa-user-friends"></i> {hotel.adults || 0} Adults</div>
                <div className="detail-badge"><i className="fas fa-child"></i> {hotel.children || 0} Children</div>
                <div className="detail-badge"><i className="fas fa-bed"></i> {hotel.beds || 0} Beds</div>
                <div className="detail-badge"><i className="fas fa-bath"></i> {hotel.baths || 0} Baths</div>
                <div className="detail-badge"><i style={{ color: '#f59e0b' }} className="fas fa-star"></i> {hotel.ratings || 0} Rating</div>
              </div>

              {/* Host Section (Refreshed & Cleaned UI) */}
              <section className="host-section-card">
                <div className="host-info-wrapper">
                  <div className="host-avatar">
                    <img
                      src={hotel.host_image ? `${uploadUrl}${hotel.host_image}` : `https://ui-avatars.com/api/?name=${hotel.full_name || 'Host'}&background=0049b0&color=fff`}
                      alt={hotel.full_name || "Host"}
                    />
                  </div>
                  <div className="host-details">
                    <h4 className="host-name">Hosted by {hotel.full_name || "Bookly"}</h4>
                    <div className="host-meta">
                      <span className="host-duration">{hotel.customer_date || "0 months"} hosting</span>
                      <a href={`/host-profile/${hotel.customer_id || ''}`} className="host-profile-link">View Profile</a>
                    </div>
                  </div>
                </div>
                <button 
                  type="button" 
                  className="message-host-btn" 
                  onClick={() => window.location.href = `/chat?host_id=${hotel.customer_id || ''}`}
                >
                  <i className="far fa-comment-dots"></i> Message this Host
                </button>
              </section>

              {/* About Section */}
              <section className="detail-section">
                <h3 className="section-heading">Details</h3>
                <div className="section-text" dangerouslySetInnerHTML={{ __html: hotel.content }} />
              </section>

              {/* Calendar Layout */}
              <section className="detail-section">
                <div className="section-head-row">
                  <div>
                    <h3 className="section-heading">Select check-in date</h3>
                    <p className="section-subtext">
                      {checkIn && checkOut
                        ? <span className="selected-date-text">Selected: {this.formatDateString(checkIn)} - {this.formatDateString(checkOut)} ({this.getNights()} nights)</span>
                        : 'Minimum stay: 1 night'}
                    </p>
                  </div>
                </div>

                <div className="calendar-box">
                  <button type="button" className="cal-nav-btn cal-nav-left" onClick={() => this.changeMonth('leftCalendarBase', -1)} aria-label="Previous month">
                    <i className="fas fa-chevron-left" />
                  </button>
                  <button type="button" className="cal-nav-btn cal-nav-right" onClick={() => this.changeMonth('leftCalendarBase', 1)} aria-label="Next month">
                    <i className="fas fa-chevron-right" />
                  </button>

                  <div className="row g-4 calendar-months">
                    <div className="col-md-6 calendar-column">
                      {this.renderCalendarMonth(leftCalendarBase)}
                    </div>
                    <div className="col-md-6 calendar-column calendar-second d-none d-md-block">
                      {this.renderCalendarMonth(nextMonthBase)}
                    </div>
                  </div>

                  <div className="calendar-footer">
                    <button type="button" className="clear-date-btn" onClick={() => this.setState({ checkIn: null, checkOut: null })}>
                      Clear dates
                    </button>
                  </div>
                </div>
              </section>

              <Facilities postId={this.props.params?.id} />

              <section className="detail-section">
                <h3 className="section-heading">Location Map</h3>
                <div className="map-card position-relative overflow-hidden" 
                  style={{ borderRadius: "12px", height: "450px" }}>
                  <iframe
                    title="Property Location Map"
                    src={`https://www.google.com/maps?ll=${hotel.map_latitude},${hotel.map_longitude}&z=14&output=embed`}
                    loading="lazy"
                    allowFullScreen=""
                    style={{ 
                      border: 0, 
                      width: "100%", 
                      height: "100%", 
                      pointerEvents: "none"
                    }}
                  />
                  <div
                    className="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center shadow"
                    style={{
                      width: "130px",
                      height: "130px",
                      borderRadius: "50%",
                      backgroundColor: "rgba(255, 255, 255, 0.4)",
                      backdropFilter: "blur(8px)",
                      WebkitBackdropFilter: "blur(8px)",
                      border: "2px solid rgba(255, 255, 255, 0.8)",
                    }}>
                    <i className="bi bi-house-door-fill text-primary" style={{ fontSize: "2rem" }}></i>
                  </div>
                </div>
              </section>

              <GuestReviews postId={this.props.params?.id} />
              
            </div>

            {/* Right Sticky Booking Sidebar */}
            <div className="col-lg-4 animate-slide-up" id="booking-sidebar-section">
              <aside className="booking-sidebar">
                <div className="booking-price-row">
                  <div>
                    <span className="booking-price">BDT {pricePerNight}</span>
                    <span className="booking-unit"> /day</span>
                  </div>

                  {post_booking_status === 1 && (
                    <div className="instant-book">
                      <i className="fas fa-bolt" /> Instant Book
                    </div>
                  )}
                </div>

                <div className="booking-box">
                  <div className="booking-date-row" onClick={() => this.setState(p => ({ showSidebarCalendar: !p.showSidebarCalendar }))} role="button" tabIndex={0}>
                    <div className="booking-date-cell">
                      <span>CHECK-IN</span>
                      <strong>{this.formatDateString(checkIn)}</strong>
                    </div>
                    <div className="booking-date-cell">
                      <span>CHECK-OUT</span>
                      <strong>{this.formatDateString(checkOut)}</strong>
                    </div>
                  </div>

                  {/* SIDEBAR DROPDOWN CALENDAR */}
                  {showSidebarCalendar && (
                    <div className="sidebar-calendar-dropdown">
                      <div className="sidebar-calendar-header">
                        <button type="button" className="mini-nav-btn" onClick={(event) => { event.stopPropagation(); this.changeMonth('rightCalendarBase', -1); }} aria-label="Previous month">
                          <i className="fas fa-chevron-left" />
                        </button>
                        <span>Select dates</span>
                        <button type="button" className="mini-nav-btn" onClick={(event) => { event.stopPropagation(); this.changeMonth('rightCalendarBase', 1); }} aria-label="Next month">
                          <i className="fas fa-chevron-right" />
                        </button>
                      </div>

                      {this.renderCalendarMonth(rightCalendarBase)}

                      <div className="sidebar-calendar-footer">
                        <button type="button" className="sidebar-close-btn" onClick={() => this.setState({ showSidebarCalendar: false })}>
                          Close
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Guest Selection */}
                  <div className="guest-selector">
                    {[
                      ['rooms', 'Rooms'],
                      ['adults', 'Adults'],
                      ['children', 'Children'],
                    ].map(([type, label]) => (
                      <div className="guest-row" key={type}>
                        <span>{label}</span>
                        <div className="guest-controls">
                          <button type="button" className="qty-btn" onClick={() => this.handleGuestChange(type, 'sub')} aria-label={`Decrease ${label}`}>-</button>
                          <strong>{this.state[type]}</strong>
                          <button type="button" className="qty-btn" onClick={() => this.handleGuestChange(type, 'add')} aria-label={`Increase ${label}`}>+</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* --- REDESIGNED TEXTAREA --- */}
                <div className="remarks-wrapper">
                  <div className="remarks-icon">
                    <i className="far fa-comments"></i>
                  </div>
                  <div className="remarks-content">
                    <div className="remarks-title">Ask anything you want</div>
                    <textarea
                      className="remarks-textarea"
                      rows="2"
                      placeholder="Write Something..."
                      name="remarks"
                      value={remarks}
                      onChange={this.handleInputChange}
                    ></textarea>
                  </div>
                </div>

                {checkIn && checkOut ? (
                  <div className="price-summary">
                    <div>
                      <span>BDT {pricePerNight} x {totalNights} nights x {rooms} room(s)</span>
                      <strong>BDT {roomPrice}</strong>
                    </div>
                    <div>
                      <span>Cleaning fee</span>
                      <strong>BDT {cleaningFee}</strong>
                    </div>
                    <div>
                      <span>Taxes (0%)</span>
                      <strong>BDT {tax.toFixed(2)}</strong>
                    </div>
                    <div className="discount-row">
                      <span>Special Discount</span>
                      <strong>- BDT {discount}</strong>
                    </div>
                    <div className="summary-divider" />
                    <div className="grand-total">
                      <span>Grand Total</span>
                      <strong>BDT {grandTotal.toFixed(2)}</strong>
                    </div>
                  </div>
                ) : (
                  <div className="date-warning">
                    Please select dates to see total price.
                  </div>
                )}

                <button type="button" className="reserve-btn" disabled={!checkIn || !checkOut} onClick={this.handleBooking}>
                  Reserve Now
                </button>
                <div className="booking-note">You won't be charged yet</div>
                <div className="booking-mini-info">
                  <i className="fas fa-shield-alt" /> Secure booking & instant confirmation
                </div>
              </aside>
            </div>
          </div>
        </div>

        {/* MOBILE STICKY BOTTOM ACTION BAR */}
        <div className="mobile-sticky-bar d-flex d-lg-none">
          <div className="mobile-sticky-price-info">
            <span className="mobile-price-amount">BDT {pricePerNight.toLocaleString()}</span>
            <span className="mobile-price-unit"> /day</span>
          </div>

          <button 
            type="button" 
            className="mobile-sticky-reserve-btn"
            onClick={() => {
              if (checkIn && checkOut) {
                this.handleBooking();
              } else {
                this.scrollToBooking();
              }
            }}
          >
            {checkIn && checkOut ? "Reserve" : "Select Dates"}
          </button>
        </div>

      </div>
    );
  }
}

export default withNavigation(PostDetail);
